module.exports = __webpack_public_path__ + "media/images/knockout__pickarrow--inactive@3x-4161d31682963bff3502ed873f34decf.png";